import { createContext, useContext } from 'react';
import { TrackProps } from './types';

export const TRACK_ID = 'Track';

export type TrackContextProps = Partial<TrackProps> & { showSwipeHalfCard?: boolean };

const TrackContext = createContext<TrackContextProps>({});

export const TrackContextProvider = TrackContext.Provider;
export const useTrackContext = () => useContext(TrackContext);

export const fadeColors = {
    light: 'hsla(0, 0%, 100%, 0), #fff',
    dark: 'rgba(12, 12, 13, 0) 0%, #0C0C0D 100%',
};
